// Vendor libraries
import { combineReducers, createReducer, on } from '@ngrx/store';
import { ReportNamingConvention } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/enums/naming-convention.enum';
// NgRx actions
import { setPreviewSecurities, setPreviewSecurityNamingConvention } from './preview-securities.action';
const primary = createReducer({ securityId: null, securityName: null }, on(setPreviewSecurities, (state, action) => {
    return action.primary;
}));
const secondary = createReducer({ securityId: null, securityName: null }, on(setPreviewSecurities, (state, action) => {
    return action.secondary;
}));
const comparison = createReducer([], on(setPreviewSecurities, (state, action) => {
    return action.comparison;
}));
const namingConvention = createReducer(ReportNamingConvention.TRUNCATED, on(setPreviewSecurities, (state, action) => {
    return action.namingConvention;
}), on(setPreviewSecurityNamingConvention, (state, action) => {
    return action.namingConvention;
}));
const moduleErrorURL = createReducer('', on(setPreviewSecurities, (state, action) => {
    return action.moduleErrorURL;
}));
export const preview_securities = combineReducers({
    primary,
    secondary,
    comparison,
    namingConvention,
    moduleErrorURL,
});
